import { render, staticRenderFns } from "./Lcls.vue?vue&type=template&id=bbd8548e"
import script from "./Lcls.vue?vue&type=script&lang=js"
export * from "./Lcls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports